import * as ActionTypes from './actionTypes'


export const  initializeContainerForm=(container)=>{


  return {
        type: ActionTypes[`GET_ITEM_CONTAINER_TAB`],
        payload:container,
        meta: { tableName: "containerList" }
    }

 }